<template>
  <div>

    <div class="card">
        <div class="qrcode">
          <img :src="$store.state.assetUrl + consultant.wechat_qrcode" alt="">
        </div>
        <div class="info">
          <div class="name">{{consultant.name}} <span>{{consultant.job}}</span></div>
          <div class="desc">
            <a-icon type="phone"></a-icon> {{consultant.mobile}}
          </div>
          <div class="desc">
            <a-icon type="mail"></a-icon> {{consultant.email}}
          </div>
          <div class="desc">
            <a-icon type="wechat"></a-icon> {{consultant.wechat_account}}
          </div>
          <div class="sub-desc">
            有任何疑问请联系我，我将竭诚为您服务！
          </div>
        </div>
    </div>
  </div>
</template>

<script>
let self;
export default {
  name: 'consultant',
  data(){
    return {
      consultant:{}
    }
  },
  mounted(){
    self = this;
    this.getConsultant();
  },
  methods:{
    getConsultant(){
      this.$http.get('getConsultant').then((res)=>{
        self.consultant = res.data;
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .card{
    background: #222338;
    padding: 2rem;
    display: flex;
    width: 640px;
    border-radius: 10px;
  }
  .qrcode{
    width: 300px;
    padding-right: 1.5rem;
    text-align: center;
  }
  .qrcode img{
    width: 100%;
    margin-bottom: 8px;
    
  }
  .card .info{
    padding-left: 1.5rem;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }
  .card .info .name{
    font-size: 28px;
    margin-bottom: 15px;
    color: #fff;
   
  }
  .card .info .name span{
    font-size: 14px;
  }
  .card .info .desc{
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 10px;
  }
  .card .info .desc .anticon{
    margin-right: 10px;
  }
  .card .sub-desc{
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
  }
</style>
